<div
  ngbDropdown
  #panel="ngbDropdown"
  class="nv-dropdown"
  placement="bottom-right"
  container="body"
  autoClose="outside"
  (openChange)="alCambiarPanel($event)"
>
  <button
    type="button"
    class="nv-trigger"
    ngbDropdownToggle
    [attr.aria-label]="contador ? 'Novedades: ' + contador + ' sin leer' : 'Novedades'"
  >
    <i class="material-icons" aria-hidden="true">campaign</i>
    <span class="nv-trigger-text">Novedades</span>
    <span *ngIf="contador" class="nv-count">{{ contador > 9 ? '9+' : contador }}</span>
  </button>

  <div ngbDropdownMenu class="nv-menu">
    <div class="nv-menu-head">
      <div class="nv-menu-title">Novedades</div>
      <div class="nv-menu-sub">Actualizaciones, comunicados y mantenimientos de la plataforma.</div>
    </div>

    <button *ngIf="pendientes.length" type="button" class="nv-pendientes" (click)="panel.close(); verPendientes()">
      <i class="material-icons" aria-hidden="true">mark_email_unread</i>
      <span>Ver {{ contador === 1 ? 'la novedad pendiente' : 'las ' + contador + ' novedades pendientes' }}</span>
    </button>

    <div class="nv-lista">
      <button
        *ngFor="let item of historial"
        type="button"
        class="nv-item"
        [class.is-nueva]="!item.vista && !item.cancelada"
        [disabled]="abriendo === item.uuid"
        (click)="abrirDesdeHistorial(item, panel)"
      >
        <i class="material-icons nv-item-icon" aria-hidden="true" [style.color]="item.comportamiento?.color">{{ item.comportamiento?.icono }}</i>
        <span class="nv-item-body">
          <span class="nv-item-title">{{ item.titulo }}</span>
          <span class="nv-item-meta">
            {{ item.comportamiento?.etiqueta }}
            <ng-container *ngIf="item.codigoVersion"> · {{ item.codigoVersion }}</ng-container>
            · {{ formatearFecha(item.fechaPublicacion) }}
          </span>
        </span>
        <span *ngIf="item.cancelada" class="nv-pill is-muted">Cancelada</span>
        <span *ngIf="!item.vista && !item.cancelada" class="nv-pill">Nueva</span>
      </button>

      <div *ngIf="cargandoHistorial" class="nv-estado">
        <div class="page-spinner"></div>
        <span>Consultando novedades...</span>
      </div>
      <div *ngIf="!cargandoHistorial && errorHistorial" class="nv-estado is-error">
        <span>{{ errorHistorial }}</span>
        <button type="button" class="nv-link" (click)="cargarHistorial(1)">Reintentar</button>
      </div>
      <div *ngIf="!cargandoHistorial && !errorHistorial && historial.length === 0" class="nv-estado">
        No hay novedades publicadas.
      </div>
    </div>

    <button
      *ngIf="!cargandoHistorial && paginaHistorial < totalPaginasHistorial"
      type="button"
      class="nv-mas"
      (click)="cargarHistorial(paginaHistorial + 1)"
    >
      Ver más
    </button>
  </div>
</div>
